<template>
  <div class="sidebar-container">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <sidebar-menu class="sidebar-menu" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarMenu from './SidebarMenu'

export default {
  components: { SidebarMenu, Logo },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    showLogo() {
      return false
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  height: 100%;
  background-color: #304156;
  
  .sidebar-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }
}
</style> 